var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdueEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03535 4.2002H3.1C3.04477 4.2002 3 4.24497 3 4.3002V12.6002C3 12.6554 3.04477 12.7002 3.1 12.7002H12.9C12.9552 12.7002 13 12.6554 13 12.6002V4.3002C13 4.24497 12.9552 4.2002 12.9 4.2002H10.9978V5.58046H9.7978L9.7978 4.2002H6.23535L6.23535 5.58046H5.03535L5.03535 4.2002ZM4.17647 7.13281V11.3919C4.17647 11.4471 4.22124 11.4919 4.27647 11.4919H11.7235C11.7788 11.4919 11.8235 11.4471 11.8235 11.3919V7.13281L4.17647 7.13281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.99951L11 4.28523L9.8 4.28523L9.8 2.99951L11 2.99951Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23999 2.99951L6.23999 4.28523L5.03999 4.28523L5.03999 2.99951L6.23999 2.99951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueEvent);
export default __webpack_public_path__ + "static/media/overdue-event.7fc91e43e3a65a852aff869ee23af306.svg";
export { ForwardRef as ReactComponent };